import { normalizeVehicleNumber } from "../../../utils/vehicleNumberUtils";

export function vehicleGroupKey(item) {
  const plate = normalizeVehicleNumber(item?.vehicleNumber);
  if (plate) return `v:${plate}`;
  return `c:${String(item?.caseId || item?._id || "unknown")}`;
}

export function assemblePendingVehicleGroups(items, groupsFromApi = []) {
  const byId = new Map(
    (Array.isArray(items) ? items : []).map((item) => [String(item._id), item])
  );

  if (Array.isArray(groupsFromApi) && groupsFromApi.length) {
    return groupsFromApi
      .map((group) => {
        const requests = (group.confirmationIds || [])
          .map((id) => byId.get(String(id)))
          .filter(Boolean);
        if (!requests.length) return null;
        const latest = requests[0];
        return {
          vehicleKey: group.vehicleKey || vehicleGroupKey(latest),
          vehicleNumber: group.vehicleNumber || latest.vehicleNumber || "",
          requestCount: requests.length,
          requests,
        };
      })
      .filter(Boolean);
  }

  const map = new Map();
  for (const item of items || []) {
    const key = vehicleGroupKey(item);
    const existing = map.get(key);
    if (!existing) {
      map.set(key, {
        vehicleKey: key,
        vehicleNumber: item.vehicleNumber || "",
        requests: [item],
      });
    } else {
      existing.requests.push(item);
    }
  }

  return [...map.values()].map((group) => ({
    ...group,
    requestCount: group.requests.length,
  }));
}

export function formatVehicleRequestCount(count) {
  const n = Number(count) || 0;
  return `${n} Request${n === 1 ? "" : "s"}`;
}

export function vehicleRequestsPath(vehicleKey) {
  return `/confirmation/vehicle/${encodeURIComponent(String(vehicleKey || ""))}`;
}

export function formatPendingListCount(vehicleTotal, requestTotal) {
  const vehicles = Number(vehicleTotal) || 0;
  const requests = Number(requestTotal) || 0;
  const vehicleLabel = `${vehicles} Vehicle${vehicles === 1 ? "" : "s"}`;
  const requestLabel = `${requests} Request${requests === 1 ? "" : "s"}`;
  return `${vehicleLabel} · ${requestLabel}`;
}
